module.exports = __webpack_public_path__ + "static/media/arrow_open_text.90b99abd.svg";